import { FixedProduct } from '@/domain/product/query/use-get-fix-main-product';

export interface NavItem {
  title: string;
  url: string;
  isActive?: boolean;
  items?: NavItem[] | ProductNavItem[];
}

export interface ProductNavItem extends Omit<NavItem, 'items'> {
  thumbnailImageUrl?: string;
  productLineBackgroundColor?: string;
}

const convertProductToProductNavItem = (products: FixedProduct[]): ProductNavItem[] => {
  return products.map((product) => ({
    title: product.productShortName,
    url: `/product/${product.descriptionId}`,
    thumbnailImageUrl: product.thumbnailImageUrl ?? undefined,
    productLineBackgroundColor: product.productLineBackgroundColor ?? undefined,
  }));
};

export function getNavItems(fixedProducts: FixedProduct[]): NavItem[] {
  const productNavItem: ProductNavItem[] = convertProductToProductNavItem(fixedProducts);

  return [
    {
      title: 'HOME',
      url: '/',
    },
    {
      title: 'CAMPAIGN',
      url: '/campaign',
    },
    {
      title: 'REWARD',
      url: '/reward',
    },
    {
      title: 'NEWSFEED',
      url: '/newsfeed',
    },
    {
      title: 'PRODUCT',
      url: '/product',
      items: productNavItem,
    },
    {
      title: 'FAQ',
      url: '/faq',
    },
    {
      title: 'SETTING',
      url: '/setting',
    },
  ];
}
